import DesktopBeginAtStart from "@app/components/industries-sections/desktop/begin-at-the-start";
import DesktopFindYourPlan from "@app/components/industries-sections/desktop/find-your-plan";
import DesktopHeroBanner from "@app/components/industries-sections/desktop/hero-banner";
import DesktopIndustriesGradient from "@app/components/industries-sections/desktop/industries-gradient";
import DesktopDistributionWarehouse from "@app/components/industries-sections/desktop/offerings/distribution-warehouse";
import DesktopHealthcare from "@app/components/industries-sections/desktop/offerings/healthcare";
import DesktopHoaResidential from "@app/components/industries-sections/desktop/offerings/hoa-residential";
import DesktopHospitalityVenue from "@app/components/industries-sections/desktop/offerings/hospitality-venue";
import DesktopManufacturingProcessing from "@app/components/industries-sections/desktop/offerings/manufacturing-processing";
import DesktopOfficeMixedUse from "@app/components/industries-sections/desktop/offerings/office-mixed-use";
import DesktopRetailGrocery from "@app/components/industries-sections/desktop/offerings/retail-grocery";
import DesktopThumbOnPulse from "@app/components/industries-sections/desktop/thumb-on-the-pulse";
import MobileIndustriesComponents from "@app/components/industries-sections/mobile";
import { useThemeContext } from "@app/contexts/theme-context";
import { useInView } from "react-intersection-observer";

const IndustriesPage = () => {
  // For transitions when scrolled on view
  const [ref, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref2, inView2] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref3, inView3] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref4, inView4] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref5, inView5] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref6, inView6] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });
  const [ref7, inView7] = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  const { isTablet, isMobile } = useThemeContext();

  return (
    <section>
      {(isTablet || isMobile) ? (
        <MobileIndustriesComponents />
      ) : (
        <section>
          <div className="flex flex-col items-center">
            <DesktopHeroBanner />
            <DesktopThumbOnPulse />
            <DesktopIndustriesGradient />
          </div>
          <div className="pb-56 pt-52 px-24 flex flex-col justify-center">
            <div ref={ref}>
              <DesktopRetailGrocery inView={inView} />
            </div>
            <div ref={ref2}>
              <DesktopManufacturingProcessing inView2={inView2} />
            </div>
          </div>
          <div ref={ref3}>
            <DesktopHospitalityVenue inView3={inView3} />
          </div>
          <div ref={ref4}>
            <DesktopDistributionWarehouse inView4={inView4} />
          </div>
          <div ref={ref5}>
            <DesktopHealthcare inView5={inView5} />
          </div>
          <div ref={ref6}>
            <DesktopOfficeMixedUse inView6={inView6} />
          </div>
          <div ref={ref7}>
            <DesktopHoaResidential inView7={inView7} />
          </div>
          <DesktopBeginAtStart />
          <DesktopFindYourPlan />
        </section>
      )}
    </section >
  )
}

export default IndustriesPage;
